// Pick a pay period → see summary → download CSV.

import { useEffect, useState } from 'react';
import { api } from '../../api';

function hours(sec) { return ((sec || 0) / 3600).toFixed(2); }

export default function PayrollExportPage() {
  const [periods, setPeriods] = useState([]);
  const [periodId, setPeriodId] = useState(null);
  const [summary, setSummary] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.listPayPeriods().then(rows => {
      setPeriods(rows);
      if (rows[0]) setPeriodId(rows[0].id);
    }).catch(e => setErr(e.message));
  }, []);

  useEffect(() => {
    if (!periodId) return;
    api.payPeriodSummary(periodId).then(setSummary).catch(e => setErr(e.message));
  }, [periodId]);

  async function lockPeriod() {
    setBusy(true);
    try { await api.lockPayPeriod(periodId); const rows = await api.listPayPeriods(); setPeriods(rows); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  }
  async function approvePeriod() {
    setBusy(true);
    try { await api.approvePayPeriod(periodId); const rows = await api.listPayPeriods(); setPeriods(rows); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  }
  function download() {
    const url = api.exportPayrollCsv(periodId);
    // Inject auth via fetch + blob
    const token = localStorage.getItem('token');
    const pinToken = localStorage.getItem('pinSession');
    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(pinToken ? { 'X-Pin-Session': pinToken } : {}),
      },
    }).then(r => r.blob()).then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `payroll-period-${periodId}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    });
  }

  const period = periods.find(p => p.id === periodId);

  return (
    <div className="page">
      <div className="page-header">
        <h2>Payroll Export</h2>
        <div className="filter-bar">
          <select value={periodId || ''} onChange={e => setPeriodId(parseInt(e.target.value, 10))}>
            {periods.map(p => (
              <option key={p.id} value={p.id}>
                {p.start_date} → {p.end_date} ({p.status})
              </option>
            ))}
          </select>
          <button className="btn-secondary" onClick={lockPeriod} disabled={busy || !period || period.status !== 'open'}>Lock Period</button>
          <button className="btn-secondary" onClick={approvePeriod} disabled={busy || !period || period.status === 'approved' || period.status === 'exported'}>Approve</button>
          <button className="btn btn-gold" onClick={download} disabled={!periodId}>Download CSV</button>
        </div>
      </div>
      {err && <div className="error-banner">{err}</div>}
      {summary && (
        <table className="data-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Username</th>
              <th>Regular</th>
              <th>OT</th>
              <th>PTO</th>
              <th>Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {summary.summaries.map(s => (
              <tr key={s.user_id}>
                <td>{s.full_name}</td>
                <td className="muted">{s.username}</td>
                <td>{hours(s.regular_seconds)}h</td>
                <td>{hours(s.ot_seconds)}h</td>
                <td>{hours(s.pto_seconds)}h</td>
                <td><strong>{hours(s.regular_seconds + s.ot_seconds + s.pto_seconds)}h</strong></td>
                <td><span className={`status-pill status-${s.approval_status}`}>{s.approval_status}</span></td>
              </tr>
            ))}
            {summary.summaries.length === 0 && <tr><td colSpan="7" className="empty">No timecards in this period yet.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
